import { defineComponent as _defineComponent } from 'vue'
import { EXTENDS_PARAM_NAME_FOR_PATENT_FAMILY } from '@/subview_plugins/patent-family/constants';
import CompareRoot from '@/views/root/CompareRoot.vue';
import ViewRoot from '@/views/root/ViewRoot.vue';
import Bowser from 'bowser';
import PtPageNotFound from 'library-@/components/PtPageNotFound.vue';
import { getViewParamsByRoute } from 'library-@/utils/get-params';
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import { useCompareUrlState } from '@/composables/use-compare-url-state';
// @ts-ignore
// window.queryObj = {};


export default /*#__PURE__*/_defineComponent({
  __name: 'PatentView',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const { isCompareView } = useCompareUrlState();

const viewParams = computed(() => {
    return getViewParamsByRoute(route, {
        /* 忽略 patentFamily 的扩展 query 参数*/
        omits: [EXTENDS_PARAM_NAME_FOR_PATENT_FAMILY],
        /* 将 pf 转为 _familyType 接口需要*/
        trans: []
    });
});

function handleKeydown(e: KeyboardEvent) {
    debugger
}

const isRouterReady = ref(false);

router.onReady(() => isRouterReady.value = true);

const browser = Bowser.getParser(window.navigator.userAgent);
const { name, version } = browser.getBrowser();

const browserClass = [
    `browser-name--${name?.replace(/ /g, '-').toLowerCase()}`,
    `browser-version--${parseInt(version || '', 10)}`,
    `browser-os--${browser.getOSName(true)}`
];

/* 统计用户的常用窗口尺寸 */
window.rvTrack('User Screen Size', { height: window.innerHeight, width: window.innerWidth });

return { __sfc: true,route, router, isCompareView, viewParams, handleKeydown, isRouterReady, browser, name, version, browserClass, CompareRoot, ViewRoot, PtPageNotFound }
}

})